module.exports = __webpack_public_path__ + "static/img/map__logo.bfa1bbef.svg";